export default __webpack_public_path__ + "static/media/corner-eidolon.86a7fa62.webp";